import { render } from "./ShowDetailDialog.vue?vue&type=template&id=c3f4f012&ts=true"
import script from "./ShowDetailDialog.vue?vue&type=script&lang=ts"
export * from "./ShowDetailDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__